<template>
  <div id="app">
    <Navbar />
    <router-view />
    <FooterSection></FooterSection>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import FooterSection from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    FooterSection
  },
  mounted() {
    // Disable right-click context menu
    document.addEventListener('contextmenu', this.disableRightClick);

    // Disable F12 key for opening Developer Tools
    document.addEventListener('keydown', this.disableF12);
  },
  beforeUnmount() {
    // Remove event listeners when the component is destroyed
    document.removeEventListener('contextmenu', this.disableRightClick);
    document.removeEventListener('keydown', this.disableF12);
  },
  methods: {
    disableRightClick(event) {
      event.preventDefault();
    },
    disableF12(event) {
      if (event.keyCode === 123) { // F12 key code
        event.preventDefault();
        event.returnValue = false;
      }
    }
  }
};
</script>
